document.addEventListener("DOMContentLoaded", function () {
    const megaMenu = document.querySelector(".category-slider-menu");
    if (!megaMenu) return;

    function initCategoryMenu() {
        const shopLinks = document.querySelectorAll("a");
        let targetLinks = [];

        shopLinks.forEach(link => {
            if (link.textContent.trim().toLowerCase() === "shop by category") {
                targetLinks.push(link);
            }
        });

        targetLinks.forEach(targetLink => {
            if (targetLink.dataset.mobileInitialized === "true") return;
            targetLink.dataset.mobileInitialized = "true";

            // Add a small dropdown arrow icon right after the "Shop by Category" text
            if (!targetLink.querySelector(".shop-category-arrow")) {
                const arrowSpan = document.createElement("span");
                arrowSpan.className = "shop-category-arrow";
                arrowSpan.setAttribute("aria-hidden", "true");
                arrowSpan.innerHTML = "&#9662;"; // ▾
                targetLink.appendChild(arrowSpan);
            }

            targetLink.addEventListener("click", function (e) {
                e.preventDefault();
                e.stopPropagation();

                const parentLi = this.closest("li") || this.parentElement;
                const arrowEl = this.querySelector(".shop-category-arrow");

                if (window.innerWidth <= 1024) {
                    // Mobile view handling: Append/Toggle inside mobile drawer list item
                    if (!parentLi.contains(megaMenu)) {
                        parentLi.appendChild(megaMenu);
                    }
                    megaMenu.classList.toggle("is-visible");
                    if (megaMenu.classList.contains("is-visible")) {
                        megaMenu.style.display = "block";
                    } else {
                        megaMenu.style.display = "none";
                    }
                } else {
                    // Desktop view handling
                    if (parentLi && !parentLi.classList.contains("has-custom-mega-wrapper")) {
                        parentLi.classList.add("has-custom-mega-wrapper");
                        parentLi.appendChild(megaMenu);
                    }
                    megaMenu.classList.toggle("is-visible");
                    megaMenu.style.display = "block";
                }

                if (arrowEl) {
                    arrowEl.classList.toggle("is-open", megaMenu.classList.contains("is-visible"));
                }
            });
        });
    }

    initCategoryMenu();

    const observer = new MutationObserver(function () {
        initCategoryMenu();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    megaMenu.addEventListener("click", function (e) {
        e.stopPropagation();
    });

    document.addEventListener("click", function (e) {
        if (megaMenu.classList.contains("is-visible")) {
            if (!megaMenu.contains(e.target) && !e.target.textContent.toLowerCase().includes("shop by category")) {
                megaMenu.classList.remove("is-visible");
                if (window.innerWidth <= 1024) {
                    megaMenu.style.display = "none";
                }
                document.querySelectorAll(".shop-category-arrow.is-open").forEach(arrow => {
                    arrow.classList.remove("is-open");
                });
            }
        }
    });

    const slider = document.querySelector(".category-slider");
    const prevBtn = document.querySelector(".cat-prev");
    const nextBtn = document.querySelector(".cat-next");

    if (slider && prevBtn && nextBtn) {
        // Slide by the slider's own visible width so each click moves
        // exactly one "page" (on mobile that's ~2 category tabs, since
        // each tab is sized to ~50% of the slider width via CSS).
        function getScrollAmount() {
            return slider.clientWidth || 220;
        }

        prevBtn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            slider.scrollBy({ left: -getScrollAmount(), behavior: "smooth" });
        });
        nextBtn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            slider.scrollBy({ left: getScrollAmount(), behavior: "smooth" });
        });
    }

    const tabs = document.querySelectorAll(".category-item");
    const panels = document.querySelectorAll(".category-products");

    function switchTab(selectedTab) {
        if (!selectedTab) return;
        tabs.forEach(tab => tab.classList.remove("active"));
        panels.forEach(panel => panel.classList.remove("active"));

        selectedTab.classList.add("active");
        const targetId = selectedTab.getAttribute("data-tab");
        const targetPanel = document.getElementById(targetId);
        if (targetPanel) {
            targetPanel.classList.add("active");
        }

        // On mobile, also bring the selected tab into view (in case it was
        // reached via arrow-scrolling) and keep it snapped nicely.
        if (window.innerWidth <= 768 && slider) {
            selectedTab.scrollIntoView({
                behavior: "smooth",
                inline: "start",
                block: "nearest"
            });
        }
    }

    tabs.forEach(tab => {
        tab.addEventListener("mouseenter", function () {
            if (window.innerWidth > 1024) {
                switchTab(this);
            }
        });
        tab.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            switchTab(this);
        });
    });
});